<bs-digital-summary [isTeaser]="true" [oddsDisplayFormat]="oddsDisplayFormat" />
